import { request } from '@umijs/max';

/** 作业列表 GET /robot/work/list */
export function getWorkList(
  data: API.PageParams & API.WORK.WorkSearch = {
    pageNum: 1,
    pageSize: 12,
  },
) {
  const { pageNum, pageSize, ...searchQuery } = data;
  return request<API.ListResponse<API.WORK.Work>>('/robot/work/list', {
    method: 'GET',
    params: data,
  });
}

/** 新增周期作业任务 POST /robot/work/addNext */
export function createWork(data: API.WORK.NewWork) {
  return request<API.CommonResponse>('/robot/work/addNext', {
    method: 'POST',
    data,
  });
}

/** 编辑作业任务 PUT /robot/work/edit */
export function updateWork(data: Partial<API.WORK.Work>) {
  return request<API.CommonResponse>('/robot/work/edit', {
    method: 'PUT',
    data,
  });
}

/** 删除作业任务 DEL /robot/work/delete */
export function deleteWork(id: number | number[]) {
  // if (id instanceof Array) {
  //   return request<API.BaseResponse>('/robot/work/delete', {
  //     method: 'POST',
  //     data: {
  //       id,
  //     },
  //   });
  // }
  return request<API.BaseResponse>(`/robot/work/${id}`, {
    method: 'DELETE',
  });
}

/** 复制作业任务 POST /robot/work/copy */
export function duplicateWork(id: number) {
  return request<API.BaseResponse>('/robot/work/copy', {
    method: 'POST',
    data: {
      id,
    },
  });
}

/** 获取作业详情 GET /robot/work/info/{workId} */
export function getWorkDetail(id: number) {
  return request<API.CommonResponse<API.WORK.WorkDetail>>(
    `/robot/work/info/${id}`,
    {
      method: 'GET',
    },
  );
}

/** 修改点位信息 PUT /robot/work/waypoint/edit */
export function setWayPointTask(data: API.WORK.WayPointTask) {
  return request<API.BaseResponse>('/robot/work/waypoint/edit', {
    method: 'PUT',
    data,
  });
}

export const WORK_ACTIONS: Record<
  API.TASK.TaskMode,
  { value: number; label: string; description?: string; disabled?: boolean }
> = {
  // '电力设备检查' = 1,
  // '消防通道检查' = 2,
  // '灭火设备检查' = 3,
  // '环境卫生检查' = 4,
  // '照明设备检查' = 5,
  // '行为监测' = 6,
  // '展品保护状态监测' = 7,
  1: {
    value: 1,
    label: '电力设备检查',
    description: '检查电力设备是否完好，接口有无损坏，并确保无杂物遮挡',
  },
  2: {
    value: 2,
    label: '消防通道检查',
    description: '检查消防通道是否保持畅通，无任何车辆或杂物违规占用',
  },
  3: {
    value: 3,
    label: '灭火设备检查',
    description: '识别灭火器等设备是否在位、压力正常，以确保可以正常使用',
  },
  4: {
    value: 4,
    label: '环境卫生检查',
    disabled: true,
  },
  5: {
    value: 5,
    label: '照明设备检查',
    disabled: true,
  },
  6: {
    value: 6,
    label: '行为监测',
    disabled: true,
  },
  7: {
    value: 7,
    label: '展品保护状态监测',
    disabled: true,
  },
};
